import React from 'react';
import { connect } from 'react-redux'

import './css/style.css';
import './css/ui-style.css';

import LoadingScreen from 'react-loading-screen';

import { hotjar } from 'react-hotjar';

import PropsManager from './components/propsManager';
import MapContainer from './components/map/mapContainer';
import MainCard from './components/menu/mainCard';
import TimelineCard from './components/timeline/timelineCard';
import TreeCard from './components/popUpItem/treeCard';
// import Graph from './components/popUpGraph/graph';
import Card from './components/popUpCard/card';
import { _ } from './functions/translator.js';
import LoadingLevel from './components/popUpLoading/loadingLevel';
import Message from './components/popUpMessage/message';
import FiltersSet from './components/menu/filtersSet';
import Legend from './components/popUpLegend/legend';
import Signature from './components/popUpSignature/signature';
import PopUpMenu from './components/popUpMenu/popUpMenu';
import PopUpWhatsAppObservations from './components/popUpWhatsAppObservations/PopUpWhatsAppObservations';
import AddProgressCard from './components/popUpAddProgress/addProgressCard';
import CycleNameCard from './components/popUpMenu/cycles/cycleNameCard';
import ProtocolSelectCard from './components/popUpMenu/protocolSelectCard.js';
import HoverInfo from './components/map/hoverInfo';
import ReleaseDate from './components/popUpReleaseDate/releaseDate';
import TeamSelector from './components/popUpTeamSelector/teamSelector';
import MetricsContainer from './components/popUpMetrics/metricsContainer';
import { templateColors } from './constants/constants';
import OnStageHelpIcon from './components/tutorial/helpIcon.js';
import DemoContainer from './components/tutorial/demoContainer.js';
import ChangeCategory from './components/popUpAdminComponents/changeCategory.js';
import ChangeLevel from './components/popUpAdminComponents/changeLevel.js';
import PaidButton from './components/menu/paidButton.js';
import SignaturesFilterHistoric from './components/popUpSignature/signaturesFilterHistoric.js';
import RegisterSelect from './components/popUpMenu/registerSelect.js';
import TunnelSubdivisions from './components/popUpMenu/tunnelSubdivisions.js';
import GanttChartDates from './components/popUpMenu/ganttChartDates.js';
import HotkeysButton from './components/hotkeys/HotkeysButton.js';
import WhatsAppButton from './components/whatsapp/WhatsAppButton.js';
import MetricsButton from './components/popUpMetrics/MetricsButton.js';

class App extends React.Component {

  componentDidMount() {
    const hjid = 3627116;
    const hjsv = 6;
    hotjar.initialize(hjid, hjsv);
  }

  render () {
    const logo = require('./resources/logo.png')

    let render = false
    if (this.props.projectData !== 'unset') { render = true }

    return (
        <div className="App">
            <LoadingScreen
                loading={!render}
                bgColor={templateColors['main-color']}
                spinnerColor='white'
                textColor='white'
                logoSrc={logo}
                text={ _('Cargando...') }
                children=''>
            </LoadingScreen>
            <PropsManager/>
            {render ? (
                <div>
                    <MapContainer/>
                    <TreeCard/>
                    <MainCard/>
                    <LoadingLevel/>
                    <FiltersSet/>
                    <Legend/>
                    <TimelineCard/>
                    {/* <Graph/> */}
                    <Message/>
                    {/* <OnStageHelpIcon/> */}
                    <MetricsContainer/>
                    <HoverInfo/>
                    <Signature/>
                    <ChangeCategory/>
                    <ChangeLevel/>
                    <TeamSelector/>
                    <ReleaseDate/>
                    <AddProgressCard/>
                    <PaidButton></PaidButton>
                    <CycleNameCard/>
                    <ProtocolSelectCard/>
                    <RegisterSelect></RegisterSelect>
                    <PopUpMenu/>
                    <PopUpWhatsAppObservations/>
                    <Card/>
                    <DemoContainer/>
                    <SignaturesFilterHistoric/>
                    <TunnelSubdivisions/>
                    <GanttChartDates/>
                    <HotkeysButton/>
                    <WhatsAppButton/>
                    <MetricsButton/>
                </div>
            ):(<div></div>)}
        </div>
    );
  }
}

function mapStateToProps( state ) {
  return {
    projectData : state.projectData
  }
}

export default connect(mapStateToProps)(App);
